var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLoader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "#7c88b1",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M20 12a8 8 0 11-16 0 8 8 0 0116 0zM6.495 12a5.505 5.505 0 1011.01 0 5.505 5.505 0 00-11.01 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.753 12c.689 0 1.257-.562 1.15-1.242a8.002 8.002 0 00-6.66-6.661C12.561 3.99 12 4.558 12 5.247c0 .69.565 1.233 1.237 1.388a5.504 5.504 0 014.128 4.128c.155.672.699 1.237 1.388 1.237z"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    dur: "1s",
    from: "0 12 12",
    to: "360 12 12",
    repeatCount: "indefinite"
  }))));
}

export default SvgLoader;